module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticClass: "easy",
    attrs: {
      "href": "mailto:stuff@studio308.co",
      "id": "contact-link"
    }
  }, [_vm._v("say what")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4100f39e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactButton.vue
// module id = 911
// module chunks = 1